export default __webpack_public_path__ + "static/media/signInLanding.a7fac3fa.PNG";